/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AarOrganizationResponse,
    AarOrganizationResponseFromJSON,
    AarOrganizationResponseToJSON,
} from '../models/AarOrganizationResponse';
import {
    type AddOrganizationToOrganizationGroupRequest,
    AddOrganizationToOrganizationGroupRequestFromJSON,
    AddOrganizationToOrganizationGroupRequestToJSON,
} from '../models/AddOrganizationToOrganizationGroupRequest';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type OrganizationGroupCreateRequest,
    OrganizationGroupCreateRequestFromJSON,
    OrganizationGroupCreateRequestToJSON,
} from '../models/OrganizationGroupCreateRequest';
import {
    type OrganizationGroupResponse,
    OrganizationGroupResponseFromJSON,
    OrganizationGroupResponseToJSON,
} from '../models/OrganizationGroupResponse';
import {
    type OrganizationGroupResponsePagedResult,
    OrganizationGroupResponsePagedResultFromJSON,
    OrganizationGroupResponsePagedResultToJSON,
} from '../models/OrganizationGroupResponsePagedResult';
import {
    type OrganizationGroupSearchOrderBy,
    OrganizationGroupSearchOrderByFromJSON,
    OrganizationGroupSearchOrderByToJSON,
} from '../models/OrganizationGroupSearchOrderBy';
import {
    type OrganizationGroupType,
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeToJSON,
} from '../models/OrganizationGroupType';
import {
    type OrganizationGroupUpdateRequest,
    OrganizationGroupUpdateRequestFromJSON,
    OrganizationGroupUpdateRequestToJSON,
} from '../models/OrganizationGroupUpdateRequest';
import {
    type OrganizationResponsePagedResult,
    OrganizationResponsePagedResultFromJSON,
    OrganizationResponsePagedResultToJSON,
} from '../models/OrganizationResponsePagedResult';
import {
    type OrganizationSearchOrderBy,
    OrganizationSearchOrderByFromJSON,
    OrganizationSearchOrderByToJSON,
} from '../models/OrganizationSearchOrderBy';
import {
    type ResourceFilter,
    ResourceFilterFromJSON,
    ResourceFilterToJSON,
} from '../models/ResourceFilter';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiOrganizationGroupsGetRequest {
    resourceFilter?: ResourceFilter;
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: OrganizationGroupSearchOrderBy;
}

export interface ApiOrganizationGroupsIdAarOrganizationsGetRequest {
    id: number;
}

export interface ApiOrganizationGroupsIdDeleteRequest {
    id: any;
}

export interface ApiOrganizationGroupsIdPutRequest {
    id: any;
    organizationGroupUpdateRequest: OrganizationGroupUpdateRequest;
}

export interface ApiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDeleteRequest {
    organizationGroupId: any;
    organizationId: any;
}

export interface ApiOrganizationGroupsOrganizationGroupIdOrganizationPutRequest {
    organizationGroupId: any;
    addOrganizationToOrganizationGroupRequest: AddOrganizationToOrganizationGroupRequest;
}

export interface ApiOrganizationGroupsOrganizationsGetRequest {
    organizationGroupIds?: Array<any>;
    organizationGroupType?: OrganizationGroupType;
    isActive?: boolean;
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: OrganizationSearchOrderBy;
}

export interface ApiOrganizationGroupsPostRequest {
    organizationGroupCreateRequest: OrganizationGroupCreateRequest;
}

export interface GetOrganizationGroupByIdRequest {
    id: any;
}

/**
 * 
 */
export class OrganizationGroupsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiOrganizationGroupsGet without sending the request
     */
    async apiOrganizationGroupsGetRequestOpts(requestParameters: ApiOrganizationGroupsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['resourceFilter'] != null) {
            queryParameters['ResourceFilter'] = requestParameters['resourceFilter'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/organization-groups`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiOrganizationGroupsGetRaw(requestParameters: ApiOrganizationGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationGroupResponsePagedResult>> {
        const requestOptions = await this.apiOrganizationGroupsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationGroupResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGroupsGet(requestParameters: ApiOrganizationGroupsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationGroupResponsePagedResult> {
        const response = await this.apiOrganizationGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiOrganizationGroupsIdAarOrganizationsGet without sending the request
     */
    async apiOrganizationGroupsIdAarOrganizationsGetRequestOpts(requestParameters: ApiOrganizationGroupsIdAarOrganizationsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiOrganizationGroupsIdAarOrganizationsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/organization-groups/{id}/aar-organizations`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiOrganizationGroupsIdAarOrganizationsGetRaw(requestParameters: ApiOrganizationGroupsIdAarOrganizationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AarOrganizationResponse>>> {
        const requestOptions = await this.apiOrganizationGroupsIdAarOrganizationsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AarOrganizationResponseFromJSON));
    }

    /**
     */
    async apiOrganizationGroupsIdAarOrganizationsGet(requestParameters: ApiOrganizationGroupsIdAarOrganizationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AarOrganizationResponse>> {
        const response = await this.apiOrganizationGroupsIdAarOrganizationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiOrganizationGroupsIdDelete without sending the request
     */
    async apiOrganizationGroupsIdDeleteRequestOpts(requestParameters: ApiOrganizationGroupsIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiOrganizationGroupsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/organization-groups/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiOrganizationGroupsIdDeleteRaw(requestParameters: ApiOrganizationGroupsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiOrganizationGroupsIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationGroupsIdDelete(requestParameters: ApiOrganizationGroupsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationGroupsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiOrganizationGroupsIdPut without sending the request
     */
    async apiOrganizationGroupsIdPutRequestOpts(requestParameters: ApiOrganizationGroupsIdPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiOrganizationGroupsIdPut().'
            );
        }

        if (requestParameters['organizationGroupUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationGroupUpdateRequest',
                'Required parameter "organizationGroupUpdateRequest" was null or undefined when calling apiOrganizationGroupsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/organization-groups/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationGroupUpdateRequestToJSON(requestParameters['organizationGroupUpdateRequest']),
        };
    }

    /**
     */
    async apiOrganizationGroupsIdPutRaw(requestParameters: ApiOrganizationGroupsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationGroupResponse>> {
        const requestOptions = await this.apiOrganizationGroupsIdPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationGroupResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGroupsIdPut(requestParameters: ApiOrganizationGroupsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationGroupResponse> {
        const response = await this.apiOrganizationGroupsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDelete without sending the request
     */
    async apiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters: ApiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organizationGroupId'] == null) {
            throw new runtime.RequiredError(
                'organizationGroupId',
                'Required parameter "organizationGroupId" was null or undefined when calling apiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling apiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/organization-groups/{organizationGroupId}/organization/{organizationId}`;
        urlPath = urlPath.replace('{organizationGroupId}', encodeURIComponent(String(requestParameters['organizationGroupId'])));
        urlPath = urlPath.replace('{organizationId}', encodeURIComponent(String(requestParameters['organizationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDeleteRaw(requestParameters: ApiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDelete(requestParameters: ApiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationGroupsOrganizationGroupIdOrganizationOrganizationIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiOrganizationGroupsOrganizationGroupIdOrganizationPut without sending the request
     */
    async apiOrganizationGroupsOrganizationGroupIdOrganizationPutRequestOpts(requestParameters: ApiOrganizationGroupsOrganizationGroupIdOrganizationPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organizationGroupId'] == null) {
            throw new runtime.RequiredError(
                'organizationGroupId',
                'Required parameter "organizationGroupId" was null or undefined when calling apiOrganizationGroupsOrganizationGroupIdOrganizationPut().'
            );
        }

        if (requestParameters['addOrganizationToOrganizationGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'addOrganizationToOrganizationGroupRequest',
                'Required parameter "addOrganizationToOrganizationGroupRequest" was null or undefined when calling apiOrganizationGroupsOrganizationGroupIdOrganizationPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/organization-groups/{organizationGroupId}/organization`;
        urlPath = urlPath.replace('{organizationGroupId}', encodeURIComponent(String(requestParameters['organizationGroupId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrganizationToOrganizationGroupRequestToJSON(requestParameters['addOrganizationToOrganizationGroupRequest']),
        };
    }

    /**
     */
    async apiOrganizationGroupsOrganizationGroupIdOrganizationPutRaw(requestParameters: ApiOrganizationGroupsOrganizationGroupIdOrganizationPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiOrganizationGroupsOrganizationGroupIdOrganizationPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationGroupsOrganizationGroupIdOrganizationPut(requestParameters: ApiOrganizationGroupsOrganizationGroupIdOrganizationPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationGroupsOrganizationGroupIdOrganizationPutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiOrganizationGroupsOrganizationsGet without sending the request
     */
    async apiOrganizationGroupsOrganizationsGetRequestOpts(requestParameters: ApiOrganizationGroupsOrganizationsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['organizationGroupIds'] != null) {
            queryParameters['OrganizationGroupIds'] = requestParameters['organizationGroupIds'];
        }

        if (requestParameters['organizationGroupType'] != null) {
            queryParameters['OrganizationGroupType'] = requestParameters['organizationGroupType'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['IsActive'] = requestParameters['isActive'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/organization-groups/organizations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiOrganizationGroupsOrganizationsGetRaw(requestParameters: ApiOrganizationGroupsOrganizationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationResponsePagedResult>> {
        const requestOptions = await this.apiOrganizationGroupsOrganizationsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGroupsOrganizationsGet(requestParameters: ApiOrganizationGroupsOrganizationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationResponsePagedResult> {
        const response = await this.apiOrganizationGroupsOrganizationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiOrganizationGroupsPost without sending the request
     */
    async apiOrganizationGroupsPostRequestOpts(requestParameters: ApiOrganizationGroupsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organizationGroupCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationGroupCreateRequest',
                'Required parameter "organizationGroupCreateRequest" was null or undefined when calling apiOrganizationGroupsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/organization-groups`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationGroupCreateRequestToJSON(requestParameters['organizationGroupCreateRequest']),
        };
    }

    /**
     */
    async apiOrganizationGroupsPostRaw(requestParameters: ApiOrganizationGroupsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationGroupResponse>> {
        const requestOptions = await this.apiOrganizationGroupsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationGroupResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGroupsPost(requestParameters: ApiOrganizationGroupsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationGroupResponse> {
        const response = await this.apiOrganizationGroupsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrganizationGroupById without sending the request
     */
    async getOrganizationGroupByIdRequestOpts(requestParameters: GetOrganizationGroupByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrganizationGroupById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/organization-groups/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getOrganizationGroupByIdRaw(requestParameters: GetOrganizationGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationGroupResponse>> {
        const requestOptions = await this.getOrganizationGroupByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationGroupResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationGroupById(requestParameters: GetOrganizationGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationGroupResponse> {
        const response = await this.getOrganizationGroupByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
